import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { LessonCard } from "@shared/models/card-stack"
import type { Permission } from "@shared/models/permissions"
import { handleError } from "cc-frontend/error-handling"
import type EmberStore from "cc-frontend/services/ember-store"
import type LessonEditor from "cc-frontend/services/lesson-editor"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor"
import type ModalManager from "cc-frontend/services/modal-manager"
import styles from "./attachments.module.css"

interface Sig {
  Args: {
    modelsNeededForFirstEdit: ModelsNeededForFirstEdit
    card: LessonCard
    cardStackId: string
    permissions: Array<Permission>
  }
}

export default class Attachments extends Component<Sig> {
  readonly styles = styles

  @service("ember-store") declare store: EmberStore
  @service declare lessonEditor: LessonEditor
  @service declare modalManager: ModalManager

  @action renameAttachment(cardId, attachment) {
    // let newTitle = window.prompt("What would you like to rename the file to?", attachment.title)
    swal({
      title: "What would you like to rename the file to?",
      input: "text",
      inputValue: attachment.title,
    })
      .then((newTitle) => {
        if (newTitle) {
          this.lessonEditor.renameAttachment(
            this.args.modelsNeededForFirstEdit,
            this.args.cardStackId,
            cardId,
            newTitle,
            attachment.id,
            this.args.card.attributes.attachments
          )
        }
      })
      .catch((error) => {
        if (error instanceof Error) handleError(error)
      })
  }

  @action removeAttachment(cardId, attachment) {
    swal({
      title: "Delete File?",
      text: "Are you sure you want to delete this file?",
      type: "warning",
      showCancelButton: true,
    })
      .then(() => {
        this.lessonEditor.removeAttachment(
          this.args.modelsNeededForFirstEdit,
          this.args.cardStackId,
          cardId,
          attachment
        )
      })
      .catch((error) => {
        if (error instanceof Error) handleError(error)
      })
  }

  @action trackDownloadAttachment(attachment) {
    this.lessonEditor.trackDownloadAttachment(this.args.cardStackId, attachment)
  }
}
